module.exports = __webpack_public_path__ + "static/media/tree-step-6_4.a9afad62.svg";